import { render, staticRenderFns } from "./KpiRow.vue?vue&type=template&id=066e5d37&scoped=true"
import script from "./KpiRow.vue?vue&type=script&lang=js"
export * from "./KpiRow.vue?vue&type=script&lang=js"
import style0 from "./KpiRow.vue?vue&type=style&index=0&id=066e5d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e5d37",
  null
  
)

export default component.exports